/*
 * @Author: wanxiaodong
 * @Date: 2020-01-03 16:55:05
 * @Last Modified by: wanxiaodong
 * @Last Modified time: 2025-07-24 10:53:07
 * @Description: 优化后的个人简历数据
 */
import ContentType from '../../types/content'

const publicPath = 'https://static.xd-coder.com/'

export default {
    other: '其他什么玩意儿数据',
    content: [
        {
            title: '个人概况',
            subTitle: '',
            contentData: [
                {
                    type: ContentType.TextArray,
                    data: [
                        {
                            type: ContentType.TextType,
                            data: '<strong>万孝东</strong> | 男 | 1992年 | 现居重庆',
                            span: 12,
                            html: true
                        },
                        {
                            type: ContentType.TextType,
                            data: `<strong>${new Date().getFullYear() - 2016}年+</strong>前端开发经验 | 高级前端工程师`,
                            span: 12,
                            html: true
                        },
                        {
                            type: ContentType.TextType,
                            data: '<strong>重庆理工大学</strong> | 计算机科学与技术 | 本科 | 2020.09 - 2023.06',
                            span: 24,
                            html: true
                        },
                        {
                            type: ContentType.TextType,
                            data: '求职意向：<strong>高级前端工程师 / 技术专家</strong>',
                            span: 12,
                            html: true
                        },
                        {
                            type: ContentType.TextType,
                            data: '期望城市：<strong>重庆</strong>',
                            span: 12,
                            html: true
                        }
                    ]
                }
            ]
        },
        {
            title: '联系方式',
            subTitle: '手机-邮箱-网址',
            contentData: [
                {
                    type: ContentType.TextArray,
                    data: [
                        {
                            type: ContentType.TextType,
                            data: '手机号：134****0141',
                            span: 8,
                            attr: {
                                title: '13452120141'
                            },
                            dot: true
                        },
                        {
                            type: ContentType.TextType,
                            data: '网址：<a href="https://xd-coder.com/" target="_blank">https://xd-coder.com/</>',
                            span: 8,
                            html: true
                        },
                        {
                            type: ContentType.TextType,
                            data: '在线简历：<a href="https://cv.xd-coder.com/?a=1" target="_blank">https://cv.xd-coder.com/</>',
                            span: 8,
                            html: true
                        }
                    ]
                },
                {
                    type: ContentType.TextType,
                    data: '邮箱：<a href="mailto:729779978@qq.com">729779978@qq.com</a> | <a href="mailto:xiaodonguncle@gmail.com">xiaodonguncle@gmail.com</a>',
                    html: true
                }
            ]
        },

        {
            title: '核心竞争力',
            subTitle: '',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: `<strong>技术深度与广度：</strong>${new Date().getFullYear() - 2016}年+前端开发经验，精通Vue、React生态体系，具备扎实的JavaScript/TypeScript功底；能够快速掌握新技术栈并应用到实际项目中，从jQuery到Vue3/React18的完整技术演进经历。`,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>全栈技术视野：</strong>具备Node.js后端开发经验，熟悉Nginx、Docker等运维技术，了解Python、Java、C++等多门编程语言，能够从全链路角度理解并解决技术问题。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>工程化与规范建设：</strong>主导部门级Vue组件库建设，制定前端代码规范(husky+lint-staged+eslint+commitlint等)，开发团队效率工具和脚手架，推动前端工程化进程。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>复杂项目驾驭能力：</strong>成功主导多个复杂项目开发，包括互动小说编辑器(含富文本+逻辑脑图)、低代码建站平台、企业级集采平台等，具备较强的架构设计和技术难点攻关能力。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>AIGC前沿探索：</strong>积极关注AI技术发展，搭建本地AI辅助工具，探索LLM模型应用和Diffusion生图应用，了解LLM搭建Agent流程，具备AI技术应用的前瞻性视野。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>团队协作与沟通：</strong>优秀的跨团队协作能力，能够快速理解业务需求并将其转化为技术方案；良好的抗压能力和问题解决能力，适应快节奏的互联网开发环境。',
                    html: true
                }
            ]
        },

        {
            title: '专业技能',
            subTitle: '前端技术栈',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: '<strong>核心框架：</strong>精通Vue(Vue2/Vue3)、React、Nuxt.js，熟悉Next.js等主流前端框架及其生态体系',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>编程语言：</strong>精通JavaScript(ES6+)，熟悉TypeScript类型系统，能够编写类型安全的代码',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>移动开发：</strong>熟练使用Taro、uniApp进行小程序开发，熟悉React-Native跨平台App开发',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>UI组件库：</strong>熟练使用ElementUI、iView、VantUI、Ant Design等主流UI组件库',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>工程化工具：</strong>熟悉Webpack、Vite、Gulp等构建工具，熟练配置Babel、ESLint、Prettier等开发工具',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>跨平台开发：</strong>熟悉Electron桌面应用开发，了解React-Native移动应用开发',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>前端规范：</strong>熟练搭建前端代码规范体系(husky+lint-staged+eslint+stylelint+commitlint+prettier+EditorConfig)',
                    html: true
                }
            ]
        },

        {
            title: '后端及相关技能',
            subTitle: '',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: '<strong>Node.js开发：</strong>熟悉Express、Koa等Node.js框架，能够开发中间层插件和项目脚手架',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>后端语言了解：</strong>了解Python、Java、C++、PHP等后端编程语言，具备后端技术视野',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>数据库：</strong>了解MongoDB等NoSQL数据库，了解SQL基本操作',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>网络与运维：</strong>熟悉HTTP/HTTPS协议，了解网络通信原理；熟悉Nginx配置，了解Docker容器化部署',
                    html: true
                }
            ]
        },

        {
            title: '工作经历',
            subTitle: '按时间倒序',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒网络股份有限公司</strong> | 高级前端工程师 | 2018.05 - 至今',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>主要职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责公司平台各端(Web/公众号/小程序)业务项目的迭代维护和技术升级',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 主导部门Vue组件库项目搭建，提升团队开发效率和代码复用率',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责八戒筋斗云低代码建站平台的迭代维护和功能升级',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 开发前端团队效率工具和Node层插件，优化开发流程',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责八戒公采平台小程序端搭建与研发，以及集采一体化平台开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 参与公司前端技术选型、架构设计和性能优化工作',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>上海跨杰网络科技有限公司</strong> | 前端开发工程师 | 2016.11 - 2018.04',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>主要职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责公司前端平台页面的有序迭代和功能开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责公司核心工具——互动小说编辑器开发(JQuery原生，集成脑图、富文本、二叉树结构)',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责互动小说编辑器Pro版本开发(Electron+React，集成脑图、富文本、多叉树)',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                }
            ]
        },

        {
            title: '核心项目经历',
            subTitle: '精选代表性项目',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒公采集采一体化平台</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2025.01 - 至今 | <strong>技术栈：</strong>Nuxt3+Vue3+Pinia+ElementPlus+Unocss',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>搭建公采新版集采一体化平台，实现采购流程的全流程数字化管理，提升采购效率和透明度。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责整体项目的技术选型、架构设计和开发维护',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Nuxt3+Vue3搭建现代化前端架构，采用Pinia进行状态管理',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 集成ElementPlus组件库和Unocss原子化CSS框架，提升开发效率和页面性能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化前端路由设计和组件复用，确保项目的可维护性和扩展性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>八戒公采PC端项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2022 - 至今 | <strong>技术栈：</strong>Vue2+Vuex+ElementUI',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责八戒公采PC端项目的开发和维护迭代，主导整个项目的技术框架升级和技术方向，确保项目的技术先进性和可维护性。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 主导PC端项目的技术框架升级，从传统架构升级到Vue2现代化架构',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责项目技术方向的制定和实施，确保技术选型的合理性和前瞻性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Vue2+Vuex进行状态管理，ElementUI作为UI组件库',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责PC端业务功能的开发和维护，确保功能的完整性和稳定性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化项目架构和代码质量，提升团队开发效率',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 制定前端开发规范，推动代码规范化和工程化建设',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决项目中的技术难题和性能瓶颈问题',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>八戒公采重庆服务超市web端项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2022 - 至今 | <strong>技术栈：</strong>Vue2+Vuex+iView',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责八戒公采重庆服务超市web端项目的维护迭代和功能开发，确保平台业务的稳定运行和持续优化。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责重庆服务超市web端项目的业务功能迭代和日常维护',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Vue2+Vuex进行状态管理，iView作为UI组件库',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责页面功能开发和bug修复，确保系统稳定性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化页面性能和用户体验，提升系统响应速度',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 参与需求分析和技术方案设计，确保业务需求的准确实现',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 与后端团队协作，完成接口对接和数据交互',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 参与代码审查和技术分享，提升团队整体技术水平',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>公采平台工作台订单系统</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2022 - 至今 | <strong>技术栈：</strong>Vue2+ElementUI+Vuex',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责公采平台工作台订单系统的开发和维护，处理采购订单的全生命周期管理，包括订单创建、审批、执行、结算等核心功能。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责订单系统的前端功能开发和维护工作',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Vue2+Vuex进行状态管理，ElementUI作为UI组件库',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 实现订单创建、编辑、审批、执行等核心业务流程',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 开发订单列表、详情、统计等页面和组件',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化订单系统性能，提升系统响应速度和用户体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 处理订单状态管理和流程控制逻辑',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 与后端团队协作，完成订单系统接口对接和数据交互',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决订单系统中的技术问题和性能瓶颈',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 参与需求分析和系统设计，确保业务需求的准确实现',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒公采平台小程序</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2023 - 2024 | <strong>技术栈：</strong>Taro+Vue3+Pinia+VantUI',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>搭建公采平台小程序业务平台，为用户提供便捷的移动端采购服务，实现PC端和小程序端的数据互通。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责整体项目的技术选型、架构搭建、功能开发和维护',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Taro框架进行多端小程序开发，采用Vue3+Pinia技术栈',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 集成VantUI组件库，快速构建用户界面，确保良好的用户体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化小程序性能和加载速度，确保在各类设备上的流畅运行',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>公司前端底层插件优化开发项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2021 - 2022 | <strong>技术栈：</strong>NodeJS+Express',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>专注于NodeJS服务端中间层的插件开发和优化，提升前端基础设施的性能和稳定性，为公司所有前端项目提供稳定高效的底层支撑。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- <strong>主导NodeJS服务端中间层开发</strong>，设计和实施中间件升级方案',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 分析现有中间层的性能瓶颈和技术债务，制定优化策略',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 重构核心中间件和插件系统，提升框架的扩展性和维护性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 基于Express框架开发通用中间件，实现请求处理、数据聚合、路由分发等核心功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 建立统一的错误处理机制和日志监控体系，提升问题排查效率',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 开发通用工具库和Helper函数，提升团队开发效率',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化服务端接口性能，减少响应时间，提升用户体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 建立中间层框架的文档和测试体系，确保升级过程的稳定性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 指导团队进行中间件升级，提供技术支持和培训',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决中间层的兼容性问题，确保现有业务平稳迁移',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒筋斗云前端业务基础组件库</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2019 - 2020 | <strong>技术栈：</strong>Webpack+Vue2',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>开发部门级Vue组件库，统一UI风格和交互规范，提升团队开发效率和代码复用率。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责组件库的整体架构设计和项目搭建',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 开发和封装常用业务组件，提供完整的组件API和使用文档',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 配置Webpack打包流程，输出NPM组件包供团队内部使用',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 建立组件库版本管理和发布流程，确保组件的稳定性和可维护性',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒筋斗云低代码模版建站平台</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2019 - 2022 | <strong>技术栈：</strong>Nuxt+Vue2+Vuex+NodeJS',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>迭代猪八戒筋斗云模版建站平台，为中小企业用户提供快速建站服务，通过可视化编辑和模版选择实现低代码建站。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责平台的功能升级和项目结构优化',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 通过共用组件模式切换和网站数据JSON化实现数据的保存和站点内容渲染',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化平台性能和用户体验，提升建站效率',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决平台技术债务，重构核心模块，提升代码质量',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒移动端Web项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2018 - 2022 | <strong>技术栈：</strong>NodeJS+Velocity → Nuxt2+Vue2+NodeJS+Dubbo+WebWorker',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责猪八戒平台移动端Web项目的开发和维护，主导项目从传统NodeJS+Velocity架构升级到现代化Nuxt2+Vue2架构的技术变革，实现移动端业务功能的完整呈现和用户体验优化。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- <strong>主导技术架构升级</strong>，将项目从NodeJS+Velocity模板架构成功迁移到Nuxt2+Vue2现代化架构(2018-2020年)',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责移动端Web项目的业务迭代和功能开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Nuxt2+Vue2构建移动端应用，实现SSR服务端渲染',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 通过NodeJS中间层对接Java、Dubbo接口，实现数据聚合和业务逻辑处理',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 集成WebWorker实现后台任务处理，提升页面性能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化移动端页面加载速度和用户体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒PC端Web项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2018 - 2019 | <strong>技术栈：</strong>Vue2+Velocity模板+NodeJS+Dubbo',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责猪八戒平台PC端Web项目的开发和维护，支撑PC端业务功能的完整呈现。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责PC端Web项目的业务迭代和功能开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Vue2进行前端开发，Velocity模板进行页面渲染',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 通过NodeJS中间层对接后端Dubbo接口，实现数据交互',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化PC端页面性能和用户交互体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决PC端兼容性问题和性能瓶颈',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>猪八戒平台小程序端项目</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2018 - 2019 | <strong>技术栈：</strong>Taro+ReactJS',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>负责猪八戒平台小程序端项目的开发和维护，为用户提供便捷的小程序端服务体验。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责小程序端项目的业务迭代和功能开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用Taro框架进行跨端小程序开发，基于ReactJS技术栈',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 实现微信小程序和其他平台小程序的适配开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化小程序性能和用户体验',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 解决小程序兼容性和性能问题',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>互动小说平台基于(Electron+React) 巧书编辑器Pro</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2017.10 - 2018.04 | <strong>技术栈：</strong>Electron+React+Redux+Webpack',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>在原有编辑阅读的基础上开发Pro版本编辑器，支持更丰富的互动内容和跨平台桌面应用。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 基于二叉交互互动小说的所有功能，开发跨平台桌面App(Windows、macOS)',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 在原编辑器基础上添加多分支+无限循环+游戏属性等高级功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 集成更丰富的富文本内容支持和跨平台App安装功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 使用React+Redux进行状态管理，Webpack进行模块化构建',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>互动小说平台在线(逻辑脑图+富文本)编辑器+阅读器</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2016.11 - 2018.04 | <strong>技术栈：</strong>JavaScript+jQuery+Gulp+Sass',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>开发平台核心工具——互动内容编辑器和阅读器，支持逻辑脑图编辑和富文本内容创作，实现二叉树分支结构。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 逻辑编辑器：集成富文本+脑图逻辑+实时编辑保存+数据备份+前进后退+预览等功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 富文本编辑器：开发多个版本的富文本编辑器(原生command富文本、markdown解析编辑器、draftjs衍生开发编辑器)',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 阅读器：将存储的内容输出并根据用户交互进行逻辑阅读',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 可视化逻辑脑图：实现可交互可视化的逻辑脑图结构编辑功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 采用全原生+jQuery开发，手动实现富文本编辑功能，向后端输出JSON数据存储',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>互动小说平台</strong>',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目时间：</strong>2016.11 - 2018.04 | <strong>技术栈：</strong>JavaScript+jQuery+Gulp+Sass',
                    html: true,
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>项目描述：</strong>开发互动小说移动PC自适应平台网站，支持文字、音频、视频、特效等多种互动内容形式，持续迭代平台内容。',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>核心职责：</strong>',
                    dot: false,
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '- 负责平台主站主要内容迭代和外投页面开发',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 开发推广H5小游戏和互动内容(文字、音频、视频、特效等)',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 实现video、audio、canvas、svg、逻辑脑图绘制等复杂交互功能',
                    dot: false
                },
                {
                    type: ContentType.TextType,
                    data: '- 优化平台性能和用户体验，确保多端适配和流畅运行',
                    dot: false
                }
            ]
        },

        {
            title: '技术亮点',
            subTitle: '',
            contentData: [
                {
                    type: ContentType.TextType,
                    data: '<strong>富文本编辑器开发：</strong>深度参与多个富文本编辑器项目，从原生command exec到draftjs衍生开发，具备丰富的富文本处理经验。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>逻辑脑图可视化：</strong>实现复杂的逻辑脑图编辑功能，支持二叉树和多叉树结构，具备数据可视化编辑经验。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>跨平台开发：</strong>从Web到小程序再到桌面应用(Electron)，具备全平台开发经验，能够选择合适的技术栈解决跨端问题。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>组件库建设：</strong>主导部门级Vue组件库建设，从0到1搭建组件体系，制定组件规范，具备技术规划和落地能力。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>性能优化经验：</strong>解决过内存泄漏、高并发延迟等性能问题，具备系统性能优化和故障排查能力。',
                    html: true
                },
                {
                    type: ContentType.TextType,
                    data: '<strong>AIGC技术应用：</strong>积极探索AI在前端领域的应用，搭建本地AI辅助工具，了解LLM和Diffusion模型的应用流程。',
                    html: true
                }
            ]
        }
    ]
}